import z from 'zod';

import { defineQuery } from '@nesso/common-contracts/define';
import { practiceIdSchema } from '@nesso/common-contracts/ids';
import { metadata } from '@nesso/common-contracts/schema-metadata';

export const GET_MERCHANT_ONBOARDING_STATUS_TYPE = 'merchant/get-onboarding-status';

export const getMerchantOnboardingStatus = defineQuery(
    GET_MERCHANT_ONBOARDING_STATUS_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
    }),
    z.object({
        status: z.enum(['NOT_COMPLETED', 'COMPLETED']).meta(metadata.nonSensitive),
    }),
);
